// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TagsCell-module__root--Q2e0V{position:relative;padding-right:15px}.TagsCell-module__tagsWrapper--23cOz{overflow:hidden}.TagsCell-module__tags--aazGg{display:flex;gap:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `TagsCell-module__root--Q2e0V`,
	"tagsWrapper": `TagsCell-module__tagsWrapper--23cOz`,
	"tags": `TagsCell-module__tags--aazGg`
};
module.exports = ___CSS_LOADER_EXPORT___;
